// Actions for the Communication / Notification settings feature

import {
  GET_COMMUNICATION_LIST,
  GET_COMMUNICATION_LIST_SUCCESS,
  GET_COMMUNICATION_LIST_FAIL,
  GET_COMMUNICATION_CHANNEL_LIST,
  GET_COMMUNICATION_CHANNEL_LIST_SUCCESS,
  GET_COMMUNICATION_CHANNEL_LIST_FAIL,
  CREATE_COMMUNICATION_CHANNEL,
  CREATE_COMMUNICATION_CHANNEL_SUCCESS,
  CREATE_COMMUNICATION_CHANNEL_FAIL,
  UPDATE_COMMUNICATION_CHANNEL,
  UPDATE_COMMUNICATION_CHANNEL_SUCCESS,
  UPDATE_COMMUNICATION_CHANNEL_FAIL,
  GET_COMMUNICATION_PLACEHOLDER_LIST,
  GET_COMMUNICATION_PLACEHOLDER_LIST_SUCCESS,
  GET_COMMUNICATION_PLACEHOLDER_LIST_FAIL,
  GET_NOTIFICATION_TEMPLATE_LIST,
  GET_NOTIFICATION_TEMPLATE_LIST_SUCCESS,
  GET_NOTIFICATION_TEMPLATE_LIST_FAIL,
} from "./actionType";

// Communication list
export const getCommunicationList = () => ({ type: GET_COMMUNICATION_LIST });
export const getCommunicationListSuccess = (data) => ({
  type: GET_COMMUNICATION_LIST_SUCCESS,
  payload: data,
});
export const getCommunicationListFail = (error) => ({
  type: GET_COMMUNICATION_LIST_FAIL,
  payload: error,
});

// Communication channel list
export const getCommunicationChannelList = () => ({
  type: GET_COMMUNICATION_CHANNEL_LIST,
});
export const getCommunicationChannelListSuccess = (data) => ({
  type: GET_COMMUNICATION_CHANNEL_LIST_SUCCESS,
  payload: data,
});
export const getCommunicationChannelListFail = (error) => ({
  type: GET_COMMUNICATION_CHANNEL_LIST_FAIL,
  payload: error,
});

// Create communication channel
export const createCommunicationChannel = (data) => ({
  type: CREATE_COMMUNICATION_CHANNEL,
  payload: data,
});
export const createCommunicationChannelSuccess = (data) => ({
  type: CREATE_COMMUNICATION_CHANNEL_SUCCESS,
  payload: data,
});
export const createCommunicationChannelFail = (error) => ({
  type: CREATE_COMMUNICATION_CHANNEL_FAIL,
  payload: error,
});

// Update communication channel
export const updateCommunicationChannel = (data) => ({
  type: UPDATE_COMMUNICATION_CHANNEL,
  payload: data,
});
export const updateCommunicationChannelSuccess = (data) => ({
  type: UPDATE_COMMUNICATION_CHANNEL_SUCCESS,
  payload: data,
});
export const updateCommunicationChannelFail = (error) => ({
  type: UPDATE_COMMUNICATION_CHANNEL_FAIL,
  payload: error,
});

// Communication placeholder list
export const getCommunicationPlaceholderList = () => ({
  type: GET_COMMUNICATION_PLACEHOLDER_LIST,
});
export const getCommunicationPlaceholderListSuccess = (data) => ({
  type: GET_COMMUNICATION_PLACEHOLDER_LIST_SUCCESS,
  payload: data,
});
export const getCommunicationPlaceholderListFail = (error) => ({
  type: GET_COMMUNICATION_PLACEHOLDER_LIST_FAIL,
  payload: error,
});

// Notification template list
export const getNotificationTemplateList = () => ({
  type: GET_NOTIFICATION_TEMPLATE_LIST,
});
export const getNotificationTemplateListSuccess = (data) => ({
  type: GET_NOTIFICATION_TEMPLATE_LIST_SUCCESS,
  payload: data,
});
export const getNotificationTemplateListFail = (error) => ({
  type: GET_NOTIFICATION_TEMPLATE_LIST_FAIL,
  payload: error,
});
